import {AuthorityProvider} from "../../lib/ContainerActionRules";
import {DashboardWidgetDescriptor} from "./DashboardWidget";

export class WidgetRegistry {
	private readonly descriptors: DashboardWidgetDescriptor[] = []

	register(descriptor: DashboardWidgetDescriptor): WidgetRegistry {
		if (this.descriptors.some(d => d.id == descriptor.id)) {
			throw new Error(`duplicate dashboard widget id: ${descriptor.id}`)
		}
		this.descriptors.push(descriptor)
		return this
	}

	get(id: string): DashboardWidgetDescriptor | null {
		return this.descriptors.find(d => d.id == id) || null
	}

	get all(): DashboardWidgetDescriptor[] {
		return this.descriptors.slice()
	}

	available(authorityProvider: AuthorityProvider): DashboardWidgetDescriptor[] {
		return this.descriptors.filter(d =>
			(d.authorities || []).every(a => authorityProvider.hasAuthority(a)))
	}
}
